<template>
  <div></div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { PetDurationCacheMixin } from '@/mixins/Booking/PetDurationCacheMixin'
import { AppointmentDefaultsSettingMixin } from '@/mixins/Booking/AppointmentDefaultsSettingMixin'

export default {
  name: 'AppointmentDefaultsSet',
  mixins: [PetDurationCacheMixin, AppointmentDefaultsSettingMixin],
  props: {
    serviceBasedDurationEnabled: {
      default: false
    },
    serviceSelectEnabled: {
      default: false
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'selectedPets',
      'extendBeyondSlotDuration',
      'openSlotDuration',
      'openSlotBooking'
    ]),
    selectedPetIds () {
      return this.selectedPets.length > 0 ? this.selectedPets.map(p => p.id) : []
    },
    highestPetDuration () {
      const durations = this.petDurations.filter(duration => this.selectedPetIds.includes(duration.petId))
      // Find the maximum duration among pet durations
      return durations.reduce((max, duration) => {
        const durationInMinutes = duration.hours * 60 + duration.minutes
        return durationInMinutes > max ? durationInMinutes : max
      }, 0)
    },
    fixedDuration () {
      return this.highestPetDuration ? this.highestPetDuration : this.petDurationMinutes
    },
    highestPetServiceDuration () {
      return Math.max(
        0,
        ...this.selectedPets.map(pet =>
          pet.serviceItems?.reduce(
            (sum, item) => sum + (item.durationMinutes || 0),
            0
          ) || 0
        )
      )
    }
  },
  watch: {
    highestPetDuration () {
      this.refreshDuration()
    },
    petDurationMinutes (value) {
      this.refreshDuration()
      this.setDefaultDuration(value)
    },
    highestPetServiceDuration () {
      this.refreshDuration()
    },
    serviceBasedDurationEnabled () {
      this.refreshDuration()
    },
    fixedDuration () {
      this.refreshDuration()
    },
    extendBeyondSlotDuration () {
      this.refreshDuration()
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'setDuration',
      'setDefaultDuration'
    ]),
    refreshDuration () {
      let duration
      if (this.openSlotBooking) {
        if (this.serviceSelectEnabled) {
          if (this.serviceBasedDurationEnabled) {
            duration = this.extendBeyondSlotDuration
              ? (this.highestPetServiceDuration > 0 ? this.highestPetServiceDuration : this.petDurationMinutes)
              : Math.min(this.highestPetServiceDuration, this.openSlotDuration)
          } else {
            duration = this.extendBeyondSlotDuration ? this.fixedDuration : this.openSlotDuration
          }
        } else {
          duration = this.extendBeyondSlotDuration ? this.fixedDuration : this.openSlotDuration
        }
      } else {
        if (this.serviceSelectEnabled) {
          if (this.serviceBasedDurationEnabled) {
            duration = this.highestPetServiceDuration > 0 ? this.highestPetServiceDuration : this.petDurationMinutes
          } else {
            duration = this.fixedDuration
          }
        } else {
          duration = this.fixedDuration
        }
      }
      this.setDuration(duration)
    }
  },
  created () {
    this.refreshDuration()
  }
}
</script>
